__webpack_require__.p = "/attractions/ticket/";